var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Kv',{ref:"kv"}),_c('Products'),_c('Marketing'),_c('Knowledge'),_c('News'),_c('Feature'),_c('AboutUs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }